import React, { useEffect, useRef, useState } from 'react';
import { Tooltip } from 'bootstrap';

export default function B2RFolderTreeview({ folder, selectedFolderId, documentList, onSelectFolder, onSelectAll, showAll }) {
    const [isClosed, setIsClosed] = useState(true);
    const tooltipList = useRef([]);
    useEffect(() => initializeTooltips(folder), [folder]);
    useEffect(() => handleAddResizeEvent(), []);

    function initializeTooltips(folder) {
        const tooltipTriggerList = document.querySelectorAll(`.folder[data-folder-id="${folder.id}"] .folderNames[data-bs-toggle="tooltip"]`);
        const newTooltipList = [...tooltipTriggerList].map(el => {
            return { element: el, tooltip: new Tooltip(el) };
        });

        tooltipList.current = newTooltipList;

        return () => {
            // Dispose tooltips.
            newTooltipList.map(t => t.tooltip.dispose());
        };
    }

    function handleAddResizeEvent() {
        function handleResize() {
            const newTooltipList = tooltipList.current.map(x => {
                if (x.element.offsetWidth >= x.element.scrollWidth) {
                    x.tooltip.disable();
                }
                else {
                    x.tooltip.enable();
                }
                return x;
            });

            tooltipList.current = newTooltipList;
        }

        handleResize();
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }

    function hasDocsInSubFolders(folder) {
        let subfoldersWithDocs = folder.folders.map(subFolder => hasDocsInFolderAndSubFolders(subFolder));
        return subfoldersWithDocs.find(x => x === true);
    }

    function hasDocsInFolderAndSubFolders(folder) {
        if (folder.documentIds.length > 0) {
            return true;
        }
        else {
            let subfoldersWithDocs = folder.folders.map(subFolder => hasDocsInFolderAndSubFolders(subFolder));
            return subfoldersWithDocs.find(x => x === true);
        }
    }

    let existingDocuments = documentList.filter(doc => folder.documentIds.includes(doc.referenceId) && (doc.shown || folder?.isFound));
    let docCount = existingDocuments.length;
    let handleSelectFolder = docCount > 0 ? () => onSelectFolder(folder) : undefined;
    let folderNameCursorClass = docCount > 0 ? "" : " cursor_default";
    let FolderDescContent = (<span onClick={handleSelectFolder} className={`folderName${folderNameCursorClass}`}
        data-bs-toggle="tooltip" data-bs-placement="top"
        data-bs-title={`${folder.folderName}`}>{folder.folderName} { }</span>);
    let folderDocCount = (<span>{`(${docCount})`}&nbsp;</span>);
    folderDocCount = undefined;

    let showExpandIcon = hasDocsInSubFolders(folder);
    let showExpandIconClass = showExpandIcon ? "" : " invisible";
    let folderIconClass = isClosed ? " dhicon-right-open" : " dhicon-down-open-2";
    let folderIcon = (<i className={`folderIcon${folderIconClass}${showExpandIconClass} text-sm mr-1`} onClick={() => setIsClosed(!isClosed)} />);

    let folderIconTriangleClass = isClosed ? "iconTriangleRight" : "iconTriangleDown";
    //folderIcon = (<i className={`${folderIconTriangleClass}${showExpandIconClass} mr-2`} onClick={() => setIsClosed(!isClosed)} />);

    let selectedClass = folder.id === selectedFolderId ? " selected" : "";
    let folderDesc = folder && (<div className={`${'folder'}${selectedClass}`} data-folder-id={folder.id}>
        {folderIcon}
        {folderDocCount}
        {FolderDescContent}
    </div>);

    let subfolderItems = folder.folders
        .filter(subFolder => hasDocsInFolderAndSubFolders(subFolder))
        .map(subFolder =>
            <B2RFolderTreeview key={subFolder.id}
                folder={subFolder}
                documentList={documentList}
                selectedFolderId={selectedFolderId}
                onSelectFolder={onSelectFolder} />);

    let isClosedClass = isClosed ? "hidden" : "";
    let subfolders = subfolderItems.length > 0 && (<div className={`folderList ${isClosedClass}`}>{subfolderItems}</div>);

    /*ShowAll----------------*/
    let allDocumentIds = documentList.filter(doc => doc.shown || folder?.isFound);

    let AllDocsContent = (<span onClick={onSelectAll} className="folderName"
        data-bs-toggle="tooltip" data-bs-placement="top"
        data-bs-title="Show All">All</span>);

    let showAllCount = (<span>{`(${allDocumentIds.length})`}</span>);
    showAllCount = undefined;

    let showAllIcon = (<i className="dhicon-right-open text-sm mr-1.5 invisible" />);
    // showAllIcon = (<i className="iconTriangleRight invisible" />)

    let showAllSelectedClass = "showAll" === selectedFolderId ? " selected" : "";
    let showAllDesc = showAll && (<div className={`${'folder'}${showAllSelectedClass}`} data-folder-id="showAll">
        {showAllIcon}
        {showAllCount}
        {AllDocsContent}
    </div>);
    /*----------------ShowAll*/

    return (
        <div className="folderContainer">
            {showAllDesc}
            {folderDesc}
            {subfolders}
        </div>
    );
}